import { __commonJSMin as e } from "../../../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0_canvas@3.2.0_/node_modules/@intercom/intercom-sanitizer/dist/html/custom-sanitizers.js
var t = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
	var t = { iframe: { src: [
		/^(https:)?\/\/www\.youtube(-nocookie)?\.com\/embed\/.+/,
		/^(https:)?\/\/www\.loom\.com\/embed\/.+/,
		/^(https:)?\/\/play\.vidyard\.com\//,
		/^(https:)?\/\/player\.vimeo\.com\/video\/.+/,
		/^(https:)?\/\/fast\.wistia\.(net|com)\/embed\/iframe\/.+/,
		/^(https:)?\/\/players\.brightcove\.net\/.+/,
		/^(https:)?\/\/content\.jwplatform\.com\/players\/.+/,
		/^(https:)?\/\/web\.microsoftstream\.com\/embed\/video\/.+/,
		/^(https:)?\/\/([\w-]+)\.sharepoint\.com\/:v:\/.+/,
		/^(https:)?\/\/share\.synthesia\.io\/embeds\/videos\/.+/,
		/^(https:)?\/\/embed\.app\.guidde\.com\/playbooks\/.+/,
		/^(https:)?\/\/share\.descript\.com\/embed\/.+/
	] } };
	e.default = { IFRAME: function(e, n) {
		var r = e.attributes.src;
		(!r || !t.iframe.src.some(function(e) {
			return e.test(r.value);
		})) && e.remove();
	} };
}));
//#endregion
export default t();
export { t as require_custom_sanitizers };
